import type { CompetitionClass } from "@my-agility-qs/shared";

/**
 * Utility functions to create links to ViewRunsPage with specific filters
 */

interface ViewRunsFilters {
  dog?: string;
  class?: CompetitionClass;
  /** In qq mode, 'current' means "since last MACH" instead of "current level" */
  level?: 'current' | 'all';
  /** Show only Double Qs (same-day Masters Standard + Jumpers Q pairs) */
  qq?: boolean;
  from?: string;
}

export function createViewRunsLink(filters: ViewRunsFilters = {}): string {
  const params = new URLSearchParams();

  if (filters.dog) params.set('dog', filters.dog);
  if (filters.class) params.set('class', filters.class);
  if (filters.level && filters.level !== 'all') params.set('level', filters.level);
  if (filters.qq) params.set('qq', '1');
  if (filters.from) params.set('from', filters.from);

  const search = params.toString();
  return `/view-runs${search ? '?' + search : ''}`;
}